import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { Menu, MenuItem, IconButton } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { IEditionMetadata, PackType, IPromotedTo } from '../../types/pack'
import { triggerNotification } from '../../actions/notifications'
import { getGraphicsURL } from '../../services/config'
import { copyToClipboard } from '../../services/common'
import {
  getEditionPrimaryLocation,
  generateLynxJSON,
} from '../../services/publishedGraphic'
import { concatenate, concatenateGraphicField } from '../../services/pack'
import { FlexContainer, Space } from '../../layouts'
import { Button } from '../../components'

export interface ISharingActionsComponent {
  edition: IEditionMetadata
  isPromotedTo: IPromotedTo
  pack: PackType
  dispatch: Dispatch
}

export const SharingActionsComponent = ({
  edition,
  isPromotedTo,
  pack,
  dispatch,
}: ISharingActionsComponent) => {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const portalLink = `${getGraphicsURL()}#/graphic/${edition.externalId}`
  const concatenatedTitle = concatenate(pack, edition, 'title')
  const primaryLocation = getEditionPrimaryLocation(
    edition.publishing.locations
  )

  const handleClick = (e): void => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const copyToLynx = (): void => {
    const editionTitle = concatenateGraphicField('title', edition, pack)
    const editionDescription = concatenateGraphicField(
      'description',
      edition,
      pack
    )
    const jsonToCopy = generateLynxJSON(
      primaryLocation,
      edition,
      edition.externalId,
      editionTitle,
      editionDescription,
      pack.byline
    )

    copyToClipboard(jsonToCopy, () => {
      dispatch(triggerNotification('Copied'))
    })
  }

  return (
    <>
      {primaryLocation && (
        <Space mb={6}>
          <Button
            id="auto-copy-to-lynx-editor-button"
            type="button"
            variant="contained"
            color="primary"
            onClick={copyToLynx}
          >
            Copy to Lynx Editor
          </Button>
        </Space>
      )}
      {isPromotedTo.Portal && (
        <FlexContainer>
          <Button
            id="auto-copy-portal-link-button"
            type="button"
            variant="contained"
            color="primary"
            onClick={() => {
              copyToClipboard(portalLink, () => {
                dispatch(triggerNotification('Copied'))
              })
            }}
          >
            Copy portal link
          </Button>
          <IconButton
            id="auto-copy-portal-link-menu"
            type="button"
            onClick={handleClick}
          >
            <MoreVert color="primary" />
          </IconButton>
          <Menu
            id="editon-copy-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            onClick={handleClose}
          >
            <MenuItem>
              <a
                href={`mailto:?subject=${encodeURIComponent(concatenatedTitle)}&body=${encodeURIComponent(concatenatedTitle)} ${encodeURI(portalLink)}`}
              >
                Email portal link
              </a>
            </MenuItem>
          </Menu>
        </FlexContainer>
      )}
    </>
  )
}

export const SharingActions = connect()(SharingActionsComponent)
